(function () {
  if (typeof gsap === 'undefined') return;
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);
  var hasST = typeof ScrollTrigger !== 'undefined';

  function init() {
    var heroCenterContent = document.querySelector('.hero-center-content');
    var scrollIndicator = document.querySelector('.scroll-indicator');

    if (heroCenterContent) {
      gsap.from(heroCenterContent.children, {
        opacity: 0, y: 50, stagger: 0.2, duration: 1, ease: 'power3.out', delay: 0.5
      });
    }

    if (scrollIndicator) {
      gsap.from(scrollIndicator, { opacity: 0, y: 20, duration: 0.8, ease: 'power2.out', delay: 1.5 });
      if (hasST) {
        ScrollTrigger.create({
          start: 'top -100',
          onEnter: function () { gsap.to(scrollIndicator, { opacity: 0 }); },
          onLeaveBack: function () { gsap.to(scrollIndicator, { opacity: 1 }); }
        });
      }
    }

    var indulgeSection = document.querySelector('.indulge-dark-bg');
    if (indulgeSection && hasST) {
      gsap.from(indulgeSection, {
        backgroundPosition: '50% 100%',
        scrollTrigger: { trigger: indulgeSection, start: 'top 80%', end: 'top 20%', scrub: 1 }
      });
    }

    var cookieGrid = document.querySelector('.cookie-grid');
    if (cookieGrid && hasST) {
      var cookieItems = cookieGrid.querySelectorAll('.cookie-item, .product-card');
      gsap.set(cookieItems, { opacity: 0, y: 30 });
      ScrollTrigger.create({
        trigger: cookieGrid,
        start: 'top 80%',
        onEnter: function () {
          gsap.to(cookieItems, { opacity: 1, y: 0, stagger: 0.1, duration: 0.5, ease: 'power2.out' });
        },
        once: true
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
